import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import UserAvatar from '../../../components/UserAvatar';

const MobileUserCard = ({ user, onEdit, onDelete, onToggleStatus, onResetPassword }) => {
  const [showActions, setShowActions] = useState(false);

  const getRoleBadgeColor = (role) => {
    const colors = {
      student: 'bg-accent/10 text-accent border-accent/20',
      admin: 'bg-secondary/10 text-secondary border-secondary/20',
      superadmin: 'bg-primary/10 text-primary border-primary/20'
    };
    return colors?.[role] || colors?.student;
  };

  const getStatusColor = (status) => {
    return status === 'active' ?'bg-success/10 text-success border-success/20' :'bg-muted text-muted-foreground border-border';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-4">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <UserAvatar userId={user?.id} name={user?.name} size="w-12 h-12" textSize="text-lg" />
          <div>
            <p className="font-semibold text-card-foreground">{user?.name}</p>
            <p className="text-sm text-muted-foreground">{user?.email}</p>
          </div>
        </div>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setShowActions(!showActions)}
          aria-label="More actions"
        >
          <Icon name="MoreVertical" size={18} />
        </Button>
      </div>
      <div className="flex items-center gap-2 mb-3 flex-wrap">
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${getRoleBadgeColor(user?.role)}`}>
          <Icon name={user?.role === 'student' ? 'GraduationCap' : user?.role === 'admin' ? 'Shield' : 'Crown'} size={12} />
          {user?.role?.charAt(0)?.toUpperCase() + user?.role?.slice(1)}
        </span>
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${getStatusColor(user?.status)}`}>
          <span className={`w-1.5 h-1.5 rounded-full ${user?.status === 'active' ? 'bg-success' : 'bg-muted-foreground'}`} />
          {user?.status?.charAt(0)?.toUpperCase() + user?.status?.slice(1)}
        </span>
      </div>
      <div className="flex items-center justify-between text-sm text-muted-foreground">
        <span>Last login: {formatDate(user?.lastLogin)}</span>
        <span>Joined: {formatDate(user?.registeredDate)}</span>
      </div>
      {showActions && (
        <>
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setShowActions(false)}
            aria-hidden="true"
          />
          <div className="mt-3 pt-3 border-t border-border space-y-2 relative z-20">
            <Button
              variant="ghost"
              size="sm"
              fullWidth
              onClick={() => {
                onEdit(user);
                setShowActions(false);
              }}
              iconName="Edit"
              iconPosition="left"
              className="justify-start"
            >
              Edit User
            </Button>
            <Button
              variant="ghost"
              size="sm"
              fullWidth
              onClick={() => {
                onToggleStatus(user?.id, user?.status === 'active' ? 'inactive' : 'active');
                setShowActions(false);
              }}
              iconName={user?.status === 'active' ? 'UserX' : 'UserCheck'}
              iconPosition="left"
              className="justify-start"
            >
              {user?.status === 'active' ? 'Deactivate' : 'Activate'}
            </Button>
            <Button
              variant="ghost"
              size="sm"
              fullWidth
              onClick={() => {
                onResetPassword(user?.id);
                setShowActions(false);
              }}
              iconName="KeyRound"
              iconPosition="left"
              className="justify-start"
            >
              Reset Password
            </Button>
            <Button
              variant="ghost"
              size="sm"
              fullWidth
              onClick={() => {
                onDelete(user?.id);
                setShowActions(false);
              }}
              iconName="Trash2"
              iconPosition="left"
              className="justify-start text-error hover:text-error"
            >
              Delete User
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default MobileUserCard;